import React, {useEffect, useState} from 'react';
import ButtonGroup from '@mui/material/ButtonGroup';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import icon_color from "../../../assets/images/icon_color1.svg";
import Slider from "react-slick";
import InfoIcon from '@mui/icons-material/Info';
import NewsList from "../../common/NewsList";
import ItemTimeline from "../../common/ItemTimeline";
import RecentlTimeline from "../../common/RecentTimeline";
import {getDetailDataAPI, getIndustryNThemeNewsAPI} from "../../../apis/news_service";
import {useNavigate} from "react-router-dom";
import Loading from "../../../pages/error/Loading";
import moment from "moment";


const CorpCard = ({stock}) => {
    const navigate = useNavigate();
    const goToCorp = () => navigate(`/stock/${stock.stockcode}`)

    return (
        <div className='corpCard_container'>
            <img src={icon_color} alt='stock_logo'/>
            <span className='title_sm'>{stock.stockname}</span>
            <div>
                <span className='title_lg'>{stock.stockquotes.toLocaleString()}  </span>
                <span className={stock.gappercent > 0 ? 'positive' : 'negative'}>{stock.gappercent > 0 ? '▲'+stock.gappercent : '▼'+stock.gappercent}%</span>
            </div>
            <p>{Object.values(stock.msg).join(`\n`)}</p>
            <div className='btn_border'>
                <button onClick={goToCorp}>기업 보러가기</button>
            </div>
        </div>
    )
}

const DetailBody = ({targetName, themeCode, react}) => {
    const settings = {
        dots: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        speed: 500,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 780,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: false
                }
            },
            {
                breakpoint: 550,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false
                }
            }
        ],
    };

    const today = moment().format('YY.MM.DD')
    const path = window.location.pathname.split('/');
    const category = path[1]

    const [loading, setLoading] = useState(true);
    const [orderType, setOrderType] = useState('NEWS') // 긍정뉴스 조회기준 NEWS or CHANGE
    const [stockList, setStockList] = useState([]) //산업, 테마 종목명 목록
    const [newsList, setNewsList] = useState([]) // 산업, 테마 뉴스 목록
    const [cardNews, setCardNews] = useState(true); // 뉴스 보기 형식 토글버튼
    const [timelineOrder, setTimelineOrder] = useState('item'); // 타임라인 정렬기준
    const [curate, setCurate] = useState(''); //
    const [newsSize, setNewsSize] = useState(4)
    const setTimelineMode = (e) => setTimelineOrder(e.target.value);


    useEffect(() => {
        if(!!targetName){
            getDetailDataAPI(category, targetName, themeCode)
                .then(res => {
                    const msg1 = res.tSummarymsg.replaceAll('. ', '.').replaceAll('.', '.\n')
                    const msg2 = res.mSummarymsg
                    setStockList(res.stocklist)
                    setCurate(msg1 + '\n' + msg2)
                })
            getIndustryNThemeNewsAPI(category,targetName, themeCode, react[0]).then(res => {
                setNewsList(res)
                console.log(res.length)
                setLoading(false)
            })
        }

        return () => setLoading(true)
     }, [targetName,orderType])


    return (
        <div className='industry_body'>

            <div className={`curate_box ${category}`}>
                <p className='title_sm'>{category === 'industry' ? '산업' : '테마'} 뉴스</p>
                <p className='curate_msg'>{curate}</p>
            </div>

            <div className='related_corp_area'>
                <div className='flex_layout'>
                    <span className='title_sm'>{category === 'industry' ? targetName + ' 산업' : targetName + ' 테마 '} 관련 기업</span>
                    <p>
                        <span onClick={()=>setOrderType('NEWS')} className={`${orderType === 'NEWS'? 'on' : ''}`}>{react[0]} 뉴스 많은 순</span>
                        <span className='separator'>·</span>
                        <span onClick={()=>setOrderType('CHANGE')}  className={`${orderType === 'CHANGE'? 'on' : ''}`}>{react[1]}률 높은 순</span>
                    </p>
                </div>
                <p className='sub'><InfoIcon sx={{color: '#CFCECF', fontSize: '14px', verticalAlign: 'baseline'}}/> {today} 일자 기준입니다.</p>
                {
                    stockList && stockList.length >= 4 ?
                        <Slider {...settings}>
                            {stockList.map(stock => <CorpCard key={stock.newsid} stock={stock}/>)}
                        </Slider>

                        :
                        <div className='card_container'>{stockList.map(stock => <CorpCard key={stock.newsid} stock={stock}/>)}</div>

                }

            </div>
            <div className='related_news_area'>
                <div className='flex_layout'>
                    <span className='title_sm'>{targetName}관련 뉴스</span>
                    <div className='flex_layout' style={{margin:'0'}}>
                        <Select className='timeline_order'
                                value={timelineOrder}
                                onChange={setTimelineMode}
                                sx={{display: cardNews ? 'none' : '', borderRadius: '16px'}}
                        >
                            <MenuItem value='item'>아이템순</MenuItem>
                            <MenuItem value='time'>시간순</MenuItem>
                        </Select>
                        <ButtonGroup className='toggle' variant="contained" aria-label="primary button group">
                            <button className={cardNews ? 'on' : 'off'} onClick={() => setCardNews(true)}>
                                <span className='toggle_name'>카드뉴스</span>
                            </button>
                            <button className={cardNews ? 'off' : 'on'} onClick={() => setCardNews(false)}>
                                <span className='toggle_name'>타임라인</span>
                            </button>
                        </ButtonGroup>
                    </div>
                </div>
                {loading? <Loading height={300}/> :
                    <>
                        {
                            cardNews ?
                                <NewsList newsList={newsList} type='horizontal_with_thumb' size={String(newsSize)} main='half'/>
                                :
                                timelineOrder === 'item' ?
                                    newsList.map(news => <ItemTimeline news={news}/>) : <RecentlTimeline news={newsList}/>
                        }
                        {newsList.length > newsSize &&
                            <div className={`more_news_area ${cardNews ? '' : 'disabled'}`}
                              onClick={() => setNewsSize(newsSize + 4)}>
                            뉴스 더보기 ∨
                            </div>}
                    </>
                }

            </div>
        </div>
    );
};

export default DetailBody;